var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import FormSubmissionDomainService from "../Domain/FormSubmission/FormSubmission.service";
const BASE_URL = "/aviso/formSubmission/";
export default class FormSubmissionService {
    static get(formSubmissionId) {
        return FetchService.getSingleResponse(BASE_URL + "get", {
            id: formSubmissionId,
        }).then(FormSubmissionDomainService.fromJSON);
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                // TODO: Fill
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
            return Object.assign(Object.assign({}, resp), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: resp.data.map(FormSubmissionDomainService.fromJSON) });
        });
    }
}
